<script setup lang="ts">
import SpinnerTail from '@/vue/atoms/spinner-tail.vue';
</script>

<template>
  <div class="wrap">
    <spinner-tail class="spinner" size="160px"/>
  </div>
</template>

<style lang="scss" scoped>
.wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.spinner {
  width: 50px;
  height: 50px;

  @include screen-md {
    width: 80px;
    height: 80px;
  }
}
</style>
